function switchShopifyLocale(component) {
  if (component.payload !== window.Shopify.locale) {
    var switcher = document.querySelector(`form[action="${window.Shopify.routes.root}localization"] a[data-value="${component.payload}"]`);
    if (switcher) {
      switcher.click();
    }
  }
}

function initLanguageSwitcher(experience) {
  var layers = experience.findLayersByTag('lang').layers;
  layers.forEach(function (layer) {
    layer.on(CerosSDK.EVENTS.CLICKED, switchShopifyLocale);
  })
  var activeLayer = layers.find(function(layer) {
    return layer.payload === window.Shopify.locale;
  });
  if (activeLayer) {
    activeLayer.click();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('iframe.ceros-experience').forEach(function(iframe) {
    var expId = iframe.parentNode.getAttribute('id');
    CerosSDK.findExperience(expId).done(initLanguageSwitcher).fail(function(error) {
      console.error(error);
    });
  });
});
